import React from 'react';
import { Glyphicon, Button } from 'react-bootstrap'
import * as FW from 'fw/system/FW'

class ViewFileLink extends React.Component {
    render () {
        if (this.props.storageToken == null || this.props.storageToken === "")
            return null;

        const buttonName = this.props.buttonName == null ? "Download" : this.props.buttonName;
        const buttonStyle = this.props.buttonStyle == null ? "default" : this.props.buttonStyle;
        const icon = this.props.icon == null ? "download" : this.props.icon;
        const url = FW.getSettings().fileViewUrl + this.props.storageToken;

        return (
            <Button 
                title={this.props.title} 
                bsSize="xsmall" 
                bsStyle={buttonStyle} 
                href={url} 
                target="_blank" 
                rel="noopener noreferrer">
                    <Glyphicon glyph={icon} />&nbsp;
                    {buttonName.length > this.props.wrapFileNameLength 
                        ? buttonName.slice(0, (this.props.wrapFileNameLength - 4)) + "..." + buttonName.slice(-4) 
                        : buttonName}
            </Button>
        )
    }

}

export default ViewFileLink

ViewFileLink.defaultProps = {
    title: '',
    wrapFileNameLength: 50,
};


// WEBPACK FOOTER //
// ./src/fw/components/viewFileLink/ViewFileLink.js